var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedinIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 26 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.4071 2.2232C4.4068 2.8125 4.1744 3.3776 3.7609 3.7941C3.3475 4.2107 2.7869 4.4445 2.2025 4.4442C1.618 4.4439 1.0577 4.2095 0.64463 3.7926C0.23159 3.3756 -0.00029 2.8103 0 2.221C0.00029 1.6317 0.23273 1.0666 0.64619 0.65005C1.0596 0.23354 1.6202 -0.00029 2.2047 0C2.7891 0.00029 3.3495 0.23469 3.7625 0.65162C4.1755 1.0686 4.4074 1.6339 4.4071 2.2232ZM4.4732 6.0897H0.06611V20H4.4732V6.0897ZM11.4365 6.0897H7.0514V20H11.3924V12.7004C11.3924 8.634 16.648 8.2562 16.648 12.7004V20H21V11.1894C21 4.3342 13.2214 4.5897 11.3924 7.9562L11.4365 6.0897Z",
    fill: "#C3C3C3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinIcon);
export default __webpack_public_path__ + "static/media/linkedin-icon.cffb5389aa2d12f51dc8ae2ef21c0f7a.svg";
export { ForwardRef as ReactComponent };